import { render, staticRenderFns } from "./keyword-item.vue?vue&type=template&id=47f9eb96&scoped=true&"
import script from "./keyword-item.vue?vue&type=script&lang=js&"
export * from "./keyword-item.vue?vue&type=script&lang=js&"
import style0 from "./keyword-item.vue?vue&type=style&index=0&id=47f9eb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9eb96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSnackbar,VSwitch,VTextField})
